import { assertNotNull } from '../../../../helpers/nullHelpers';
import { assertIsNumberOrNull } from '../../../../helpers/numberHelpers';
import { BuildTypeCode } from '../../../projects/project';
import { UnitHeatLossDetailsFormModel } from '../../quote-or-design-form/units/heatLoss/unitHeatLossDetailsFormModel';
import { CreateUpdateUnitFloorElementDto, mapUnitFloorElementFormModelToDto } from './createUpdateUnitFloorElementDto';
import { CreateUpdateUnitRoofElementDto, mapUnitRoofElementFormModelToDto } from './createUpdateUnitRoofElementDto';
import { CreateUpdateUnitWallElementDto, mapUnitWallElementFormModelToDto } from './createUpdateUnitWallElementDto';

export type CreateUpdateUnitHeatLossDetailsDto = {
  generalAllowanceFactorPercentage: number | null;
  exposureFactorPercentage: 0 | 10;
  propertyFootprintInMetresSquared: number | null;
  propertyExternalPerimeterInMetres: number | null;
  buildTypeCode: BuildTypeCode;
  externalAirTemperatureInDegreesCelsius: number | null;
  wallElements: Array<CreateUpdateUnitWallElementDto>;
  roofElements: Array<CreateUpdateUnitRoofElementDto>;
  floorElements: Array<CreateUpdateUnitFloorElementDto>;
};

export const mapUnitHeatLossDetailsFormModelToDto = (
  formModel: UnitHeatLossDetailsFormModel,
): CreateUpdateUnitHeatLossDetailsDto => ({
  generalAllowanceFactorPercentage: assertIsNumberOrNull(formModel.generalAllowanceFactorPercentage),
  exposureFactorPercentage: assertNotNull(formModel.exposureFactorPercentage),
  propertyFootprintInMetresSquared: assertIsNumberOrNull(formModel.propertyFootprintInMetresSquared),
  propertyExternalPerimeterInMetres: assertIsNumberOrNull(formModel.propertyExternalPerimeterInMetres),
  buildTypeCode: formModel.buildTypeCode,
  externalAirTemperatureInDegreesCelsius: assertIsNumberOrNull(formModel.externalAirTemperatureInDegreesCelsius),
  wallElements: formModel.wallElements.map(mapUnitWallElementFormModelToDto),
  roofElements: formModel.roofElements.map(mapUnitRoofElementFormModelToDto),
  floorElements: formModel.floorElements.map(mapUnitFloorElementFormModelToDto),
});
